<template>
  <div>
    <h1>{{ pageHeader }}</h1>
    <form class="lihavapp-form">
      <section>
        <label for="manufacturer">Manufacturer</label>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="manufacturer"
            name="manufacturer"
            placeholder="Scale manufacturer"
            v-model="manufacturer"
            :disabled="showModeActive"
          />
        </div>
        <div class="form-group">
          <label for="model">Model</label>
          <input
            type="text"
            class="form-control"
            id="model"
            name="model"
            placeholder="Scale model"
            v-model="model"
            :disabled="showModeActive"
          />
        </div>
        <div class="form-group">
          <label for="comment">Comment</label>
          <input
            type="text"
            class="form-control"
            id="comment"
            name="comment"
            placeholder="Optional comment"
            v-model="comment"
            :disabled="showModeActive"
          />
        </div>
      </section>

      <div class="form-group lihavapp-form-control-button-holder">
        <button
          type="button"
          class="btn btn-primary mr-3"
          v-on:click="create()"
          v-if="createModeActive"
        >Create</button>

        <button
          type="button"
          class="btn btn-secondary mr-3"
          v-on:click="update()"
          v-if="editModeActive"
        >Update</button>

        <button
          type="button"
          class="btn btn-outline-secondary"
          v-on:click="cancel()"
          v-if="createModeActive || editModeActive"
        >Cancel</button>

        <button
          type="button"
          class="btn btn-danger float-right"
          v-on:click="deleteScale"
          v-if="editModeActive"
        >Delete</button>

        <button
          type="button"
          class="btn btn-secondary"
          v-on:click="$router.push({ name: 'weight.scales' });"
          v-if="showModeActive"
        >Back</button>

        <button
          type="button"
          class="btn btn-outline-secondary float-right"
          v-on:click="edit()"
          v-if="showModeActive"
        >Edit scale</button>
      </div>
    </form>
  </div>
</template>

<script>
import { store } from "@/store.js";

export default {
  name: "ScaleShowCreateEdit",
  components: {},
  data: function() {
    return {
      store: store,
      manufacturer: "",
      model: "",
      comment: ""
    };
  },
  created: function() {},
  mounted: function() {
    if (this.showModeActive || this.editModeActive) {
      let scale = this.store.getScale(this.$route.params.id);

      if (scale == undefined) {
        return;
      }

      this.manufacturer = scale.manufacturer;
      this.model = scale.model;
      this.comment = scale.comment;
    }
  },
  computed: {
    showModeActive: function() {
      return this.$route.name == "scales.show";
    },
    createModeActive: function() {
      return this.$route.name == "scales.create";
    },
    editModeActive: function() {
      return this.$route.name == "scales.edit";
    },
    pageHeader: function() {
      if (this.showModeActive) {
        return "Show scale";
      }

      if (this.editModeActive) {
        return "Edit scale";
      }

      return "Add new scale";
    }
  },
  methods: {
    create: function() {
      var self = this;
      this.axios
        .post("scale", {
          manufacturer: self.manufacturer,
          model: self.model,
          comment: self.comment
        })
        .then(function(response) {
          self.$router.push({ name: "weight.scales" });
          // handle success
          self.flashSuccess("New scale created successfully...");
          self.store.fetchScales();
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    },
    edit: function() {
      this.$router.push({
        name: "scales.edit",
        params: { id: this.$route.params.id }
      });
    },
    update: function() {
      let self = this;
      let scale = {
        manufacturer: self.manufacturer,
        model: self.model,
        comment: self.comment
      };
      this.axios
        .put("scale/" + this.$route.params.id, scale)
        .then(function(response) {
          // handle success
          self.$router.push({ name: "weight.scales" });
          self.flashSuccess("Scale updated successfully");
          self.store.fetchScales();
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    },
    cancel: function() {
      if (this.editModeActive) {
        this.$router.push({
          name: "scales.show",
          params: { id: this.$route.params.id }
        });
      } else {
        this.$router.push({ name: "weight.scales" });
      }
    },

    deleteScale: function() {
      if (!this.editModeActive) return;

      let scale = this.store.getScale(this.$route.params.id);

      if (scale == undefined) {
        return;
      }
      let confirmationText = "Are you sure that you want to delete this scale?";

      if (!confirm(confirmationText)) {
        return;
      }

      var self = this;
      this.axios
        .delete("/scale/" + scale.id)
        .then(function(response) {
          // handle success
          let removed = self.store.removeScale(scale.id);

          if (removed) {
            self.flashSuccess("Scale deleted successfully");
          } else {
            self.flashSuccess(
              "Scale removed from server, but deleting from local data structure failed"
            );
          }

          self.$router.push({ name: "weight.scales" });
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    }
  }
};
</script>

<style scoped>
</style>